<template>
  <div class="w-full">
    <Head title="Panel — Klinika Zdrowia Rodziny" />
    <div class="mb-8">
      <h1 class="mb-2 text-3xl font-bold text-gray-900">Administracja strony Kliniki Zdrowia Rodziny</h1>
      <p class="text-gray-600">
        Zarządzaj treścią i ustawieniami strony Kliniki Zdrowia Rodziny.
      </p>
    </div>

    <div class="rounded-lg bg-white shadow-sm">
      <div class="px-6 py-5">
        <p class="text-gray-600">
          To jest panel administracyjny do zarządzania stroną statyczną Kliniki Zdrowia Rodziny.
        </p>
        <div class="mt-4">
          <Link
            :href="$routes.family_clinic()"
            class="text-sm font-medium text-indigo-600 hover:text-indigo-500"
            target="_blank"
          >
            Zobacz stronę Kliniki Zdrowia Rodziny →
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import AdminFamilyClinicLayout from '@/Layouts/AdminFamilyClinic.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: AdminFamilyClinicLayout,
};
</script>
